export default "__VITE_ASSET__1e6380b1__"